import styled from 'styled-components';

export const VerticalNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 1rem;
  width: 200px;
`;
